import { ChargerProducts } from '../common/enums/Products'
import { ChargePointImport } from '../common/redux/api/web-api'

const isLuna = (entity: { productId?: number } | number | string): boolean => {
    if (typeof entity === 'number') {
        return entity === ChargerProducts.Luna
    } else if (typeof entity === 'string') {
        return entity.toLowerCase() === 'luna'
    } else if (typeof entity === 'object' && entity.productId) {
        return entity.productId === ChargerProducts.Luna
    }

    return false
}

export const isLunaImport = (chargePoint: ChargePointImport | undefined) =>
    chargePoint && chargePoint.productType === 'Luna'

export default isLuna
